import AssignedToCell from "@pages/CommandCenter/CommandCenterTable/Cells/AssignedToCell";
import PrescriptionSubmittedCell from "@pages/CommandCenter/CommandCenterTable/Cells/PrescriptionSubmittedCell";
import SiteAndPhysicianCell from "@pages/CommandCenter/CommandCenterTable/Cells/SiteAndPhysicianCell";
import { OrderSearchOut } from "@providers/hop-ord-server/api";
import CareplanCell from "@pages/CommandCenter/CommandCenterTable/Cells/CareplanCell";
import PatientCell from "@pages/CommandCenter/CommandCenterTable/Cells/PatientCell";
import PlanningStatusCell from "@pages/CommandCenter/CommandCenterTable/Cells/PlanningStatusCell";
import CommentCell from "@pages/CommandCenter/CommandCenterTable/Cells/CommentCell";
import { useNavigate } from "react-router-dom";
import CustomTableRow from "@pages/CommandCenter/CommandCenterTable/Rows/CustomTableRow";
import { useState } from "react";

const RoTableRow = ({
  order,
  index,
}: {
  order: OrderSearchOut;
  index: number;
}) => {
  const navigate = useNavigate();

  const [rowIsHovered, setRowIsHovered] = useState(false);
  return (
    <CustomTableRow
      onMouseEnter={() => setRowIsHovered(true)}
      onMouseLeave={() => setRowIsHovered(false)}
      rowIsHovered={rowIsHovered}
      onClick={() => {
        navigate(`/review/${order.id}`);
      }}
    >
      <PatientCell
        patientName={order.patientName ?? ""}
        patientMrn={order.patientMrn ?? ""}
        patientDob={order.patientDob ?? ""}
        isTest={order.isTest}
        rowIsHovered={rowIsHovered}
      />
      <SiteAndPhysicianCell
        treatingDepartment={order.treatingDepartment ?? ""}
        treatingRo={order.treatingRo}
      />
      <PrescriptionSubmittedCell
        orderStatus={order.status}
        submittedDatetime={order.submittedDatetime ?? ""}
      />
      <CareplanCell order={order} index={index} />
      <PlanningStatusCell order={order} index={index} />
      <AssignedToCell order={order} readOnly />
      <CommentCell order={order} setRowIsHovered={setRowIsHovered} />
    </CustomTableRow>
  );
};
export default RoTableRow;
